import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home.vue"),
    children: [
      {
        path: "/admin/users",
        name: "AdminUsers",
        component: () => import("@/views/AdminUsers.vue"),
        meta: {
          title: "Quản lý nhân sự",
        },
      },
      {
        path: "/my-routine/products",
        name: "MyRoutineProducts",
        component: () => import("@/views/MyRoutineProducts.vue"),
        meta: {
          title: "Quản lý sản phẩm quiz",
        },
      },
      {
        path: "/my-routine/users",
        name: "MyRoutineUsers",
        component: () => import("@/views/MyRoutineUsers.vue"),
        meta: {
          title: "Lịch sử người dùng",
        },
      },
      {
        path: "/my-routine/users-download",
        name: "MyRoutineUsersDownload",
        component: () => import("@/views/MyRoutineUsersDownload.vue"),
        meta: {
          title: "Tải lịch sử người dùng",
        },
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
    meta: {
      title: "Đăng nhập",
    },
  },
  {
    path: "/401",
    name: "Page401",
    component: () => import("@/views/Page401.vue"),
    meta: {
      title: "Không phận sự miễn vào",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = "OLV | " + to.meta.title;
  } else {
    document.title = "OLV Admin";
  }

  next();
});

export default router;
